import { render, staticRenderFns } from "./CartaoDeContaAReceberAvulsa.vue?vue&type=template&id=11822d43&scoped=true"
import script from "./CartaoDeContaAReceberAvulsa.vue?vue&type=script&setup=true&lang=js"
export * from "./CartaoDeContaAReceberAvulsa.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CartaoDeContaAReceberAvulsa.vue?vue&type=style&index=0&id=11822d43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11822d43",
  null
  
)

export default component.exports